import { useSnackbar } from "notistack";
import { useMemo } from "react";

type NotificationType = "info" | "warning";

type AddNotificationOptions = {
	message?: string;
	type?: NotificationType;
};

function useNotifications() {
	const { enqueueSnackbar } = useSnackbar();

	return useMemo(
		() => ({
			add: ({ message, type = "info" }: AddNotificationOptions) => enqueueSnackbar(message, { variant: type }),
		}),
		[enqueueSnackbar],
	);
}

export { type NotificationType, useNotifications };
